export default __webpack_public_path__ + "static/media/IconDesc_PowerStorage.256.33e79071.png";